import createHttpInstance from "./http-common";

type Param = "id" | "brandMasterId" | "seriesModelId" | "productTypeId" | "categoryId" | "osTypeId" | "isToday" | "serviceTypeId" | "orderId" | "documentTypeId" | "amount" | "date" | "isExpressPickup" | "userAddressId" | "roleId" | "isFromPublic" | "comments" | "encryptedOrderId" | "enquiryId" | "importHistoryId";
type ContentType = "application/json-patch+json" | "application/json" | "multipart/form-data" | "blob" | "application/json; charset=utf-8; v=1.0";
type responseType = "blob" | 'arraybuffer'

class CommonService {
    async get(ControllerName: string, ModelName: string, ContentType?: ContentType, responseType?: responseType) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}`, {
            headers: { 'Content-Type': `${ContentType}`, 'responseType': `${responseType}` }
        }).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithSingleEntity(ControllerName: string, ModelName: string, value1: any,) {
        const currentDateTime = new Date().toISOString();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}/${value1}?&date=${encodeURIComponent(currentDateTime)}`).catch((err: any) => {
            let data = err?.response?.data;
            const lowerData = typeof data === "string" ? data.toLowerCase() : "";
            if (lowerData.includes("recaptcha") || lowerData.includes("security verification") || lowerData.includes("security check") || lowerData.includes("automated browser")) {
                data = "Something went wrong. Please try again";
            }
            throw { response: { data }, message: err?.message };
        });
    }

    async getWithDoubleEntity(ControllerName: string, ModelName: string, value1: any, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}/${value1}/${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithTripleEntity(ControllerName: string, ModelName: string, value1: any, value2: any, value3) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}/${value1}/${value2}/${value3}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithQueryParam(ControllerName: string, ModelName: string, Param: Param, value: any) {
        const currentDateTime = new Date().toISOString();
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value}&date=${encodeURIComponent(currentDateTime)}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithSingleParam(ControllerName: string, ModelName: string, value: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}?id=${value}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithDoubleParam(ControllerName: string, ModelName: string, Param: Param, value1: any, Param2: Param, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value1}&${Param2}=${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithTripleParam(ControllerName: string, ModelName: string, Param: Param, value: any, Param2: Param, value2: any, Param3: Param, value3: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param2}=${value2}&${Param3}=${value3}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async getWithTwoDoubleParam(ControllerName: string, ModelName: string, Param: Param, value: any, Param2: Param, value2: any, Param3: Param, value3: any, Param4: Param, value4: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.get(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param2}=${value2}&${Param3}=${value3}&${Param4}=${value4}`).catch((err: Error) => {
            throw err?.message
        });
    }


    async postWithOutData(ControllerName: string, ModelName: string) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async post(ControllerName: string, ModelName: string, data: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}`, data).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithEntityandSingleQueryParam(ControllerName: string, ModelName: string, data: any, param: Param, value: any) {
        const httpCommon = await createHttpInstance();
        const currentDateTime = new Date().toISOString();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${param}=${value}&date=${encodeURIComponent(currentDateTime)}`, data).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithDoubleEntity(ControllerName: string, ModelName: string, data1: any, data2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}/${data1}/${data2}`).catch((err: any) => {
            let data = err?.response?.data;
            const lowerData = typeof data === "string" ? data.toLowerCase() : "";
            if (lowerData.includes("recaptcha") || lowerData.includes("security verification") || lowerData.includes("security check") || lowerData.includes("automated browser")) {
                data = "Something went wrong. Please try again";
            }
            throw { response: { data }, message: err?.message };
        });
    }

    async postWithTripleEntity(ControllerName: string, ModelName: string, data1: any, data2: any, data3: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}/${data1}/${data2}/${data3}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithQuadrupleEntity(ControllerName: string, ModelName: string, data1: any, data2: any, data3: any, data4: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}/${data1}/${data2}/${data3}?${data4}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithPentaParams(ControllerName: string, ModelName: string, Param: Param, value: any, Param2: Param, value2: any, Param3: Param, value3: any, Param4: Param, value4: any, Param5: Param, value5: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value}&${Param2}=${value2}&${Param3}=${value3}&${Param4}=${value4}&${Param5}=${value5}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithSingleParam(ControllerName: string, ModelName: string, value1: any,) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}/${value1}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithQueryParam(ControllerName: string, ModelName: string, Param: Param, value: any, contentType: ContentType) {
        const currentDateTime = new Date().toISOString();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value}&date=${encodeURIComponent(currentDateTime)}`, {
            headers: { 'Content-Type': `${contentType}` }
        }).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithDoubleParam(ControllerName: string, ModelName: string, Param: Param, value1: any, Param2: Param, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value1}&${Param2}=${value2}`).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithFormData(ControllerName: string, ModelName: string, data: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).catch((err: Error) => {
            throw err
        });
    }


    async postWithFormDataWithQueryParam(ControllerName: string, ModelName: string, data: any, Param: Param, value: any, contentType: ContentType) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param}=${value}`, data, {
            headers: { 'Content-Type': `${contentType}` }
        }).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithFormDataWithDoubleQueryParam(ControllerName: string, ModelName: string, Param1: Param, Param2: Param, value1: any, value2: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}?${Param1}=${value1}&${Param2}=${value2}`, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).catch((err: Error) => {
            throw err?.message
        });
    }

    async postWithToken(ControllerName: string, ModelName: string, data: any, token: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`/${ControllerName}/${ModelName}`, data, {
            headers: {
                "XSRF-TOKEN": token,
            }
        }).catch((err: Error) => {
            throw err?.message
        });
    }

    async deleteWithQueryParam(ControllerName: string, ModelName: string, Param: Param, value: any) {
        const httpCommon = await createHttpInstance();
        return httpCommon.delete(`/${ControllerName}/${ModelName}?${Param}=${value}`).catch((err: Error) => {
            throw err?.message
        });
    }
}
export default new CommonService();